import appStyles from "./css/app-styles.css?raw";

/** Marks the outermost element inside the shadow root. `app-styles.css` hangs
 * the `all: initial` reset off this attribute, so the two must stay in sync. */
export const WIDGET_ROOT_ATTR = "data-chat-widget-root";

/** Inject additional CSS styles inside shadow root.
 *
 * By default, vite will inject styles into the main document,
 * so we need to manually inject the styles into the shadow root like this.
 */
export const injectStylesShadowRoot = (shadowRoot: ShadowRoot) => {
  const style = document.createElement("style");
  style.id = "app-styles";
  style.innerHTML = appStyles;
  shadowRoot.appendChild(style);
};
